import React from "react";
import { Link } from "react-router-dom";
import { useData } from "@/context/DataContext";
import Seo from "@/components/site/Seo";
import { PageHero } from "@/components/site/Layout";
import { Reveal } from "@/components/site/Reveal";
import BeforeAfterSlider from "@/components/site/BeforeAfterSlider";
import { WhatsAppButton } from "@/components/site/WhatsButton";

export default function BeforeAfter() {
  const { beforeAfter } = useData();
  return (
    <>
      <Seo title="Prima e dopo" description="Confronti fotografici prima e dopo degli interventi Animaverde su giardini e spazi verdi in provincia di Varese." path="/prima-e-dopo" />
      <PageHero
        overline="Trasformazioni"
        title="Prima e dopo"
        subtitle="Trascina il cursore per scoprire la differenza. I confronti attuali sono dimostrativi e verranno sostituiti con fotografie reali."
        breadcrumb={<><Link to="/" className="hover:text-av-lime">Home</Link> / <span className="text-av-white">Prima e dopo</span></>}
      />

      <section className="bg-av-black py-16 sm:py-24">
        <div className="mx-auto max-w-[1100px] px-5 sm:px-8 space-y-20">
          {beforeAfter.map((b, i) => (
            <Reveal key={b.id} delay={0.05}>
              <div className="grid lg:grid-cols-[1fr_1.5fr] gap-8 items-center">
                <div className={i % 2 === 1 ? "lg:order-2" : ""}>
                  <p className="overline text-av-bright mb-3">{b.servizio}</p>
                  <h2 className="font-display text-3xl sm:text-4xl text-av-white">{b.titolo}</h2>
                  <p className="mt-2 text-sm text-av-gray">{b.comune}</p>
                  <p className="mt-4 text-av-gray leading-relaxed">{b.descrizione}</p>
                </div>
                <BeforeAfterSlider prima={b.prima} dopo={b.dopo} altPrima={`${b.titolo} — prima`} altDopo={`${b.titolo} — dopo`} testId={`ba-slider-${b.id}`} />
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="bg-av-green-dark py-16 text-center" style={{ backgroundColor: "var(--av-green-deep)" }}>
        <div className="mx-auto max-w-2xl px-5">
          <h2 className="font-display text-3xl sm:text-4xl text-av-white">Immagina il tuo spazio trasformato</h2>
          <p className="mt-4 text-av-gray">Inviaci le fotografie del tuo giardino e richiedi un sopralluogo gratuito.</p>
          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <Link to="/contatti" className="inline-flex items-center gap-2 rounded-full bg-av-bright text-av-black px-6 py-3 text-sm font-semibold hover:bg-av-lime transition-colors">Richiedi un sopralluogo</Link>
            <WhatsAppButton variant="outline" />
          </div>
        </div>
      </section>
    </>
  );
}
